import {
  HCSA_LOADING,
  HCSA_SUCCESS,
  HCSA_FAILED
} from '../actions/hcsaActions.js'

const HCSA = (state = { isLoading: false }, action) => {
  switch (action.type) {
    case HCSA_LOADING:
      return Object.assign({}, state, {
        isLoading: true,
        error: null,
        hcsaData: null
      })
    case HCSA_SUCCESS:
      return Object.assign({}, state, {
        hcsaData: action.response,
        error: null,
        isLoading: false
      })
    case HCSA_FAILED:
      return Object.assign({}, state, {
        error: action.error,
        hcsaData: null,
        isLoading: false
      })
    default:
      return state
  }
}

export default HCSA



// WEBPACK FOOTER //
// ./src/redux/reducers/hcsaReducer.js